import { gql } from '@apollo/client'

export default gql`
  query getStoreInfo {
    getStoreInfo {
      store_error_msg
    }
  }
`
